import { createHashHistory } from "history"
export let history = createHashHistory()

// import { createBrowserHistory } from "history"
// export let history = createBrowserHistory()
